import { EsgGraphsApi } from "@/api";

export async function get(id, params) {
  const { data } = await EsgGraphsApi.get(id, params);
  return data;
}
